export default __webpack_public_path__ + "static/media/CC_SecondaryLogo_Colour.d2d871f8.svg";